import { render } from "./App.vue?vue&type=template&id=7533c3e5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7533c3e5&lang=css"

import exportComponent from "/home/runner/work/vue_restaurants/vue_restaurants/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__